import { Fragment } from 'react'

/** Runs of Japanese characters: CJK punctuation, kana, CJK ideographs and full-width forms (plans/09 5.1). The one copy of this rule in the app. */
export const JA_RUN = /([　-ヿ㐀-鿿＀-￯]+)/

/**
 * Prints a label with every run of Japanese characters wrapped in `<span lang="ja">`, so 司令室 renders in
 * Noto Sans JP and screen readers switch language (plans/09 P9.5). Backend strings stay plain text.
 */
export function JaText({ text }: { text: string }) {
  const parts = text.split(JA_RUN)
  if (parts.length === 1) return <>{text}</>
  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <span key={index} lang='ja'>
            {part}
          </span>
        ) : part ? (
          <Fragment key={index}>{part}</Fragment>
        ) : null
      )}
    </>
  )
}
